<template>
  <div class="migrationBanner">
    <b-row v-if="ShowMigrationBannerEnabled">
      <b-alert :show="ShowMigrationBannerEnabled" variant="info" class="flex-grow-1 w-100">
        <h5><i class="far fa-info-circle fa-lg" /> {{ $t('xMigrationBannerHeaderText') }}</h5>
        <p class="bannerBody ml-4">
          {{ $t('xMigrationBannerBodyText') }}
          <a class="p-0 fw-bold learnMore hoverPointer" @click="$bvModal.show('migration-info-modal')"
            >{{ $t('xLearnMoreLowercase') }}.</a
          >
        </p>
      </b-alert>
    </b-row>
    <b-modal id="migration-info-modal" centered hide-footer>
      <template #modal-header>
        <b-row class="w-100 justify-content-between py-0" align-v="center" no-gutters>
          <h2 class="modal-title"><i class="far fa-info-circle fa-md" /> {{ $t('xUpgradeYourExperience') }}</h2>
          <b-button class="btn btn-icon-button btn-icon-button--gray" @click="$bvModal.hide('migration-info-modal')">
            <i class="fas fa-times" />
          </b-button>
        </b-row>
      </template>
      <div>
        <p>{{ $t('xMigrationBannerLearnMoreModalIntro') }}</p>
        <ul>
          <li v-for="n in 7" :key="n">{{ $t(`xMigrationBannerLearnMoreModalItem${n}`) }}</li>
        </ul>
        <p>{{ $t('xMigrationBannerLearnMoreModalOutro') }}</p>
      </div>
      <div class="w-100 align-items-start mt-3">
        <MobileDownloadLinkButtons />
      </div>
    </b-modal>
  </div>
</template>

<script>
import MobileDownloadLinkButtons from '../components/Common/MobileDownloadLinkButtons.vue'

export default {
  props: ['ShowMigrationBannerEnabled'],
  components: { MobileDownloadLinkButtons }
}
</script>
<style lang="scss">
.migrationBanner {
  width: 100%;
  padding: 0 1rem;
}
.modal-header {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.bannerBody {
  font-weight: normal;
}
.learnMore {
  font-weight: bold !important;
  color: var(--carbon-900) !important;
}
</style>
